<template>
    <div v-if="designer_title">
        <div v-if="designer_url">
            <p class="card-text">
                {{text}}
                <a :href="designer_url">{{designer_title}}</a>
            </p>
        </div>
        <div v-else>
            <p class="card-text">
                {{text}} {{designer_title}}
            </p>
        </div>
    </div>

</template>

<script>
    export default {
        name: "gallery-page-text",
        props: {
            text:{
                type: String,
                required: true
            },
            designer_title: {
                type: String,
                required: false
            },
            designer_url: {
                type: String,
                required: false
            }
        }
    }
</script>

<style scoped>

</style>
